import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Shimmer placeholder bar of the Solvace UI prototypes (`.sk` + `@keyframes shimmer`, ported from Alerts):
 * `#ececf0 → #f4f4f7 → #ececf0` sweep, 1.3s ease-in-out, radius 6. Sized through `width`/`height`, so a
 * skeleton screen is composed out of bars with no local copy of the animation (`svz-data-table` uses it
 * for its loading rows).
 */
@Component({
  selector: 'svz-skeleton',
  standalone: true,
  template: '',
  styleUrls: ['./svz-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'aria-hidden': 'true',
    '[style.width]': 'width()',
    '[style.height]': 'height()',
    '[style.border-radius]': 'radius()',
  },
})
export class SvzSkeletonComponent {
  /** CSS length of the bar. The prototype's table bars are `80px` (head) and `70px`/`150px` (rows). */
  public readonly width = input<string>('100%');
  /** CSS length of the bar: `12px` for head bars, `14px` for row bars, `44px` for toolbar controls. */
  public readonly height = input<string>('14px');
  /** Corner radius; the prototype's `.sk` is `6px`, its toolbar bars override to `8px`. */
  public readonly radius = input<string>('6px');
}
